import request from "../request";
import sysrequest from "../sysrequest";
// 潛在客戶管理的api

const api = {
  // 查詢潛在客戶列表
  pocx_search(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  pocx_create(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  pocx_update(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  pocx_delete(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
